import React__default, { useContext } from 'react';
import { L as LocalizationContext } from '../../chunks/bundle-CIN9yQRB.js';
import MessageInput from '../../ui/MessageInput.js';
import { u as useOpenChannelContext } from '../../chunks/bundle-JYgg9UJ5.js';
import '../../chunks/bundle-C7jYHvwG.js';
import '../../chunks/bundle-pOZPN8hk.js';
import '../../chunks/bundle-C9dF4QVS.js';
import '../../chunks/bundle-Dpdq7qeD.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../chunks/bundle-DImSV9VW.js';
import '../../chunks/bundle-DCX2mqfp.js';
import 'dompurify';
import '../../chunks/bundle-BMygDCXK.js';
import '../../chunks/bundle-P-vXuw8U.js';
import '../../chunks/bundle-BBowfNDO.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-DUTyBaXr.js';
import '../../useSendbirdStateContext.js';
import '../../withSendbird.js';
import '../../chunks/bundle-DYeeW5nS.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-CDjVXDOc.js';
import '../../chunks/bundle-Dl9NVsui.js';
import '../../chunks/bundle-DkviGBGz.js';
import '../../chunks/bundle-_-FiwcfQ.js';
import '../../chunks/bundle-gQ2a8Eki.js';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-MyLy9AIu.js';
import 'react-dom';
import '../../chunks/bundle-DfDrbjM5.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '../../chunks/bundle-4W3uBGU3.js';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-CLonR-iH.js';
import '../../chunks/bundle-C6-Ix-Lk.js';
import '../../ui/SortByRow.js';
import '../../chunks/bundle-CzdrQ_Yq.js';
import '../../chunks/bundle-MkyS3j4-.js';
import '../../chunks/bundle-2kzSicIw.js';
import '../../chunks/bundle-BR3O1lZq.js';

var OpenChannelInput = React__default.forwardRef(function (props, ref) {
    var _a = useOpenChannelContext(), currentOpenChannel = _a.currentOpenChannel, disabled = _a.disabled, handleSendMessage = _a.handleSendMessage, handleFileUpload = _a.handleFileUpload, amIMuted = _a.amIMuted;
    var channel = currentOpenChannel;
    var stringSet = useContext(LocalizationContext).stringSet;
    var value = props.value;
    function getPlaceHolderString() {
        if (amIMuted) {
            return stringSet.MESSAGE_INPUT__PLACE_HOLDER__MUTED;
        }
        if (disabled) {
            return stringSet.MESSAGE_INPUT__PLACE_HOLDER__DISABLED;
        }
        return '';
    }
    if (!channel) {
        return null;
    }
    return (React__default.createElement("div", { className: "sendbird-openchannel-footer" },
        React__default.createElement(MessageInput, { channel: currentOpenChannel, ref: ref, value: value, disabled: disabled, isVoiceMessageEnabled: false, onSendMessage: handleSendMessage, onFileUpload: handleFileUpload, placeholder: getPlaceHolderString() })));
});

export { OpenChannelInput as default };
//# sourceMappingURL=OpenChannelInput.js.map
